import { render, staticRenderFns } from "./KinesisEndpointView.vue?vue&type=template&id=526ec6aa&scoped=true&"
import script from "./KinesisEndpointView.vue?vue&type=script&lang=ts&"
export * from "./KinesisEndpointView.vue?vue&type=script&lang=ts&"
import style0 from "./KinesisEndpointView.vue?vue&type=style&index=0&id=526ec6aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ec6aa",
  null
  
)

export default component.exports